<template>
  <div class="card" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th>Client</th>
          <th>Order Number</th>
          <th>Order Date</th>
          <th class="text-right">Order value</th>
          <th>Client Contact Person</th>
          <th>Contact Number</th>
          <th>Contact Owner</th>
          <th>Key Account Manager</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in lists" :key="i">
          <td> {{ item.party_name }}</td>
          <td>
            <button class="btn badge bg-dark bg-opacity-75 bg-primary btn-sm">
              <span>{{ item.bill_number }}</span>
            </button>
          </td>
          <td> {{ item.date }}</td>
          <td class="text-right"> {{ item.bill_amount }}</td>
          <td>
            <span v-for="contact_person in getList(item.cp_contact_persons)"
                  class="badge badge bg-dark bg-opacity-75 bg-primary">{{ contact_person }}</span>
          </td>
          <td>
            <span v-for="phone in getList(item.cp_phones)" class="badge badge bg-dark bg-opacity-75 bg-primary">{{
                phone
              }}</span>
          </td>
          <td>{{ item.contact_owner_name }}</td>
          <td>{{ item.key_account_manager_name }}</td>
          <td>
            <button v-if="item.general_count > getBookedLength(item.booked_sale_generals) && activeTab != 'cancelled'" @click="openSelectItemModal(item)"
                    class="btn btn-primary btn-sm mr-5">
              <i class="fas fa-plus"></i>
              Start Project
            </button>
            <span v-if="activeTab != 'cancelled'" class="badge badge bg-dark bg-opacity-75 bg-primary" v-for="project_master_id in JSON.parse(item.project_master_ids)"
                  @click="handleEdit(item.id, project_master_id)" style="cursor: pointer">
            {{ project_master_id }} Edit
          </span>
            <button v-if="activeTab == 'pending'" @click="handleStatusUpdate(item, 'inactive')"
                    class="btn btn-danger btn-sm ml-1" title="Cancel Order">
              <i class="fas fa-trash"></i>
            </button>
            <button v-if="activeTab == 'cancelled'" @click="handleStatusUpdate(item, 'active')"
                    class="btn btn-success btn-sm" title="Activate Order">
              <i class="fas fa-check-circle"></i>
            </button>
          </td>
        </tr>

        </tbody>
      </table>
      <p v-if="!lists.length" class="text-center mt-5">No data</p>
    </div>
  </div>
  <ItemSelectModal
      v-if="itemSelectModal"
      :ignoreGenerals="ignoreGenerals"
      :selectedItem="selectedItem"
      @onClickClose="onClickClose"
  />
</template>

<script setup>
import {inject, ref} from "vue";
import ItemSelectModal from '@/components/molecule/company/inventory/project-initiate/ItemSelectModal.vue'
import handlePurchase from "@/services/modules/purchase";
import {useRoute, useRouter} from "vue-router";

const {fetchSalesOrderById, updateProjectInitiateStatus} = handlePurchase();
const route = useRoute()
const router = useRouter()
const emit = defineEmits(['onRefresh'])
const props = defineProps({
  lists: Array,
  activeTab: String,
  companyId: [String, Number],
})

const showError = inject('showError');
const showSuccess = inject('showSuccess')

const getList = (items) => {
  if (!items) {
    return []
  }
  return items.split(',').map(item => item.trim());
}


const itemSelectModal = ref(false);
const selectedItem = ref({});
const ignoreGenerals = ref('');
const openSelectItemModal = (item) => {
  ignoreGenerals.value = ''
  const companyQuery = `?company_id=${route.params.companyId}`;

  fetchSalesOrderById(item.id, companyQuery).then((res) => {
    if (!res.data) return;

    selectedItem.value = res.data
    ignoreGenerals.value = item.booked_sale_generals
    itemSelectModal.value = true
  }).catch((err) => {
    console.log("Something went wrong");
  })
}

const onClickClose = () => {
  itemSelectModal.value = false
}
const handleEdit = (soId, projectId) => {
  route.params.soId = soId;
  route.params.projectId = projectId;
  router.push({name: `edit-project-initiate`, params: route.params, query: route.query});
}

const getBookedLength = (items) => {
  if (items == null) {
    return 0
  }
  const result = convertToArray(items);
  return result.length;
}

const convertToArray = str => {
  const cleanedStr = str.replace(/^\[\[|\]\]$/g, '');
  const subArrays = cleanedStr.split(/\],\s*\[/).map(s => s.replace(/\[|\]|"|,/g, ''));
  return subArrays.flatMap(subArray => subArray.split(' ').filter(Boolean).map(Number));
}

const handleStatusUpdate = async (item, status) => {
  const confirmMsg = status === 'inactive'
    ? 'Are you sure you want to cancel this pending project kickoff?'
    : 'Are you sure you want to activate this project kickoff?';

  if (!confirm(confirmMsg)) return;

  try {
    const res = await updateProjectInitiateStatus(item.id, {
      status,
      company_id: props.companyId
    }
    );
    if (! res.status) {
      showError(res.message)
      return;
    }
    emit('onRefresh');
    showSuccess(res.message)
  } catch (e) {
    showError('Something went wrong.')
  }
}
</script>
